import React from "react";
import { SectionReveal } from "../components/Motion";
import ProtectedEmail from "../components/ProtectedEmail";
import { useT } from "../i18n/LanguageContext";

export default function ImpressumPage() {
  const { t } = useT();
  return (
    <div className="pt-32 md:pt-40 pb-24 md:pb-32 bg-[#EFECE6] min-h-screen" data-testid="impressum-page">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <p className="col-span-12 md:col-span-3 text-[11px] uppercase tracking-[0.28em] text-[#4c535a]">
            {t.impressum.eyebrow}
          </p>
          <h1 className="col-span-12 md:col-span-9 type-display text-[#4c535a]">
            {t.impressum.title}
          </h1>
        </div>

        <SectionReveal>
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 md:col-span-6 md:col-start-4">
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#4c535a]/60 mb-4">
                {t.impressum.contact_label}
              </p>
              <div className="font-sans type-body text-[#4c535a] space-y-1">
                {t.impressum.lines.map((l) => (
                  <p key={l}>{l}</p>
                ))}
              </div>
              <p className="mt-6 font-sans type-body">
                <ProtectedEmail testId="impressum-email-link" className="text-[#4c535a] link-sweep" />
              </p>
              <p className="mt-10 font-sans text-[13px] leading-[1.8] text-[#4c535a]/65 max-w-[52ch]">
                {t.impressum.note}
              </p>
            </div>
          </div>
        </SectionReveal>
      </div>
    </div>
  );
}
